function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("g", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  fill: "#2D2D2D"
}, /*#__PURE__*/React.createElement("path", {
  d: "M8 2.077a5.923 5.923 0 00-5.308 8.555.538.538 0 01.047.339l-.523 2.8.828-.173a.63.63 0 01.02-.003l1.974-.336a.539.539 0 01.33.049A5.923 5.923 0 108 2.078zM1 8a7 7 0 114.05 6.35l-1.796.305-1.606.334a.538.538 0 01-.639-.627l.64-3.416A6.975 6.975 0 011 8z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5.308 5.846c0-.297.24-.538.538-.538h.718c.297 0 .538.24.538.538v1.436c0 .192-.1.361-.252.456.084.166.182.33.295.486.266.37.622.711 1.095.963.09-.172.27-.29.478-.29h1.436c.297 0 .538.241.538.539v.718a.539.539 0 01-.538.538c-1.899 0-3.137-.803-3.883-1.839-.727-1.009-.963-2.203-.963-3.007z"
}));
function SvgWhatsApp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}
export default __webpack_public_path__ + "/img/WhatsApp.svg";
export { SvgWhatsApp as ReactComponent };